// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:25:52

export default {
  "id": "memory-wars",
  "slug": "memory-wars",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d67ca37fc56243eb913ac8147763a955-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d67ca37fc56243eb913ac8147763a955/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Memory Wars",
      "description": "Memory Wars takes the classic memory-matching game to a whole new level with exciting battles, unique enemies, and powerful card effects. Use your brainpower and tactics to overcome a variety of foes and emerge victorious in every stage!",
      "instructions": "Tap to match cards. Each time you turn a card, you lose energy. If the cards match, you will damage the enemy.",
      "genres": [
        "Cards"
      ],
      "tags": [
        "challenge",
        "memory",
        "real-time-strategy"
      ]
    },
    "zh-CN": {
      "title": "记忆之战",
      "description": "记忆之战将经典的记忆匹配游戏提升到了全新的高度，带来了激动人心的战斗、独特的敌人和强大的卡片效果。运用你的智慧和策略，战胜各种敌人，在每个阶段脱颖而出，取得胜利！",
      "instructions": "点击匹配卡片。每次翻动卡片，你都会消耗能量。如果卡片匹配，你将对敌人造成伤害。",
      "genres": [
        "卡片"
      ],
      "tags": [
        "挑战",
        "记忆",
        "即时策略"
      ]
    },
    "zh-TW": {
      "title": "記憶之戰",
      "description": "記憶戰爭將經典的記憶配對遊戲提升至全新境界，帶來刺激的戰鬥、獨特的敵人和強大的卡片效果。運用你的智慧與策略，超越各種敵人，並在每個階段中獲得勝利！",
      "instructions": "點擊配對卡片。每次翻轉卡片，你會消耗能量。如果卡片匹配，你將會傷害敵人。",
      "genres": [
        "牌"
      ],
      "tags": [
        "挑戰",
        "記憶",
        "即時策略"
      ]
    },
    "zh-HK": {
      "title": "記憶戰爭",
      "description": "記憶戰爭將經典的記憶配對遊戲提升至全新境界，帶來刺激的戰鬥、獨特的敵人和強大的卡片效果。運用你的腦力及戰術，克服各種敵人，在每個階段中奪得勝利！",
      "instructions": "點擊配對卡片。每次翻動卡片，你會失去能量。如果卡片配對成功，你將會對敵人造成傷害。",
      "genres": [
        "牌"
      ],
      "tags": [
        "挑戰",
        "記憶",
        "即時策略"
      ]
    },
    "ja": {
      "title": "メモリウォーズ",
      "description": "メモリウォーズは、伝統的な記憶ゲームを魅力的な戦闘、ユニークな敵、そして強力なカード効果で一層奥深くします。脳力と戦術を使って、様々な敵を倒し、全ステージで勝利を手にしましょう！",
      "instructions": "カードをタップして一致させます。カードをめくるたびにエネルギーが消費されます。一致した場合、敵にダメージを与えます。",
      "genres": [
        "カード"
      ],
      "tags": [
        "挑戦",
        "記憶",
        "リアルタイムストラテジー"
      ]
    },
    "ko": {
      "title": "메모리 전쟁",
      "description": "메모리 워즈는 전통적인 기억 매칭 게임을 흥미진진한 전투, 독특한 적, 강력한 카드 효과로 완전히 새로운 수준으로 끌어올린다. 뇌력과 전략을 사용하여 다양한 적을 이겨내고 모든 단계에서 승리하세요!",
      "instructions": "카드를 탭하여 일치시켜주세요. 카드를 돌리면 에너지가 줄어듭니다. 카드가 일치하면 적을 공격합니다.",
      "genres": [
        "카드"
      ],
      "tags": [
        "챌린지",
        "기억",
        "실시간 전략"
      ]
    },
    "fr": {
      "title": "Guerres de la Mémoire",
      "description": "Memory Wars emporte le classique jeu de mémoire-couplage à un tout nouveau niveau avec des batailles captivantes, des ennemis uniques et des effets de carte puissants. Utilisez votre pouvoir intellectuel et vos tactiques pour surmonter une variété d'ennemis et triompher à chaque étape !",
      "instructions": "Tapez pour correspondre aux cartes. Chaque fois que vous retournez une carte, vous perdez de l'énergie. Si les cartes correspondent, vous causerez des dégâts à l'ennemi.",
      "genres": [
        "Cartes"
      ],
      "tags": [
        "défi",
        "mémoire",
        "stratégie en temps réel"
      ]
    }
  }
};
